angular.module('unica_workshop.workshop_services')

.factory('WorkshopDeleteService', function ($http, getBaseApiURL) {

	var workshopDeleteService = {};

	workshopDeleteService.delete = function (workshopId) {
		return $http({
			method: 'DELETE',
			url: getBaseApiURL + '/workshop/delete/' + workshopId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});
	};

	workshopDeleteService.deleteWorkshopMaterial = function (workshopId, type) {
		return $http({
			method: 'DELETE',
			url: getBaseApiURL + '/workshop/delete-workshop-material/' + workshopId + '/' + type,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.workshop;
			}

		});
	};

	workshopDeleteService.deleteWorkshopSessionInvitation = function (invitationId) {
		return $http({
			method: 'DELETE',
			url: getBaseApiURL + '/workshop/delete-workshop-session-invitation/' + invitationId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});
	};

	return workshopDeleteService;
});